import React from 'react';
import PropTypes from 'prop-types';
import { cardUserImg } from 'theme/icon';

import styles from '../styles.scss';

export default class OwnerLog extends React.PureComponent {
  static propTypes = {
    newOwnerName: PropTypes.string.isRequired,
  };

  render() {
    const { newOwnerName } = this.props;
    return (
      <div className={styles.user}>
        <img className={styles.userImage} alt="" src={cardUserImg} />
        <div className={styles.userName}>{newOwnerName}</div>
      </div>
    );
  }
}
